import React, { memo, useCallback, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux'
import { ActivityIndicator, View, FlatList, Text } from "react-native";
import AppointmentHandler from '../../components/AppointmentHandler';
import { fetchfAppointmentsFromApi } from "../../../shared/actions/FutureAppointActions";
import { GetDayName, GetAppointmentDate, GetMonthName, ReturnTypeIcon, GetYear, FormateUTCTime } from '../../../shared/core/datehelper';
import getUserInfo from '../../../shared/core/GetTokenized';
import { appServices } from '../../../shared/redux/actions/appServices';
import { Button, Modal, Spin } from 'antd';
import { notification } from "antd";
import getUserId from '../../../shared/core/GetToken';
import Settings from '../../../shared/config/Settings';
import { Link , useNavigate } from "react-router-dom";
import PortalAlerts from '../../components/PortalAlerts';
const FutureAppointmentView = props => {
    const [currentDate, setCurrentDate] = useState("");
      const [AppointmentID, setAppointmentID] = useState("");
      const [providersechduleID, setprovidersechduleID] = useState("");
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
    const PatienInformation = JSON.parse(information);
    // const { FutureAppointments, isGetting } = props.FutureAppointments;
    const [pageSize, setPageSize] = useState(100);           //state for the page number
    const [pageNumber, setPageNumber] = useState(1);           //state for the page number
    const [showAlert, setshowAlert] = useState(false)
    const [ListData, setListData] = useState(null)
    const [rescheduleModal, setRescheduleModal] = useState(false);
    const dispatch = useDispatch();
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const  {AppointmentsData , isAppointmentsLoading} =useSelector((state)=> state.Appointments);
    const {RecheduleAppointmentData , isRecheduleAppointmentData}= useSelector((state)=>state.RecheduleAppointment)
    const {AvailableSlotsForAppointmentData , isAvailableSlotsForAppointmentData}= useSelector ((state)=> state.AvailableSlotsForAppointment)
    const {AvailableDateForAppointmentData , isAvailableDateForAppointmentData}=useSelector((state)=> state.AvailableDateForAppointment)
    const [availableMonths, setAvailableMonths] = useState([])
    const [appointmentDates, setappointmentDates] = useState([]);
    const [noDatemodal, setNoDatemodal] = useState(false);
    const [confirmationmodal, setconfirmationmodal] = useState(false);
    const [appointmentSlots, setAppointmentSlots] = useState([]);
    const [selectedDuration, setSelectedDuration] = useState("")
  const [resultComfirm, setresultComfirm] = useState("");
  const [confirmSlotData, setConfirmSlotData] = useState(null);
  const [clinicName, setClinicName] = useState("")
  const [slotLoading, setSlotLoading] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  let history = useNavigate();
  const [modifiedSlots, setModifiedSlots] = useState([]);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
    const fAppointmentObj={
        PatientID: Profile && Profile[0].resource.id,
        PageSize : pageSize,
        PageNumber: pageNumber ,
        AppointmentType: 1
    }
    const dateOnly = (dateparameter) => {
        const date = new Date(dateparameter);
        if (isNaN(date.getTime())) {
          console.error("Invalid date parameter:", dateparameter);
          return "Invalid date";
        }
        const options = {
          year: "numeric",
          month: "short",
          day: "numeric",
          timeZone: "Europe/Dublin", // Force Europe/Dublin for ireland time formatting
        };
      
        // Format the date to show only the time
        const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
          date
        );
        return formattedDate;
      };
      const timeOnly = (dateparameter) => {
        const date = new Date(dateparameter);
        if (isNaN(date.getTime())) {
          console.error("Invalid date parameter:", dateparameter);
          return "Invalid date"; // Return a fallback or error message
        }
        const options = {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // 12-hour format with AM/PM
          timeZone: "Europe/Dublin", // Force UTC time formatting
        };
      
        // Format the date to show only the time
        const formattedTime = new Intl.DateTimeFormat("en-GB", options).format(
          date
        );
      
        return formattedTime.toLocaleLowerCase();
      };
    const formatTime = (time) => {
        const date = new Date(time);
        const options = {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
          timeZone: "Europe/Dublin", // Use the specific time zone, e.g., Europe/London for +01:00 offset
        };
        const formattedTime = new Intl.DateTimeFormat("en-GB", options).format(
          date
        );
    
        return formattedTime.toUpperCase();
      };
    const formatMonthYear = (date) => {
        const month = date  && monthNames[date.getMonth()];
        const year = date &&  date.getFullYear();
        return `${month} ${year}`;
      };
      useEffect(() => {
        if(appointmentSlots.length >0){
        // Check if all appointments have IsDisabled set to true
        const allDisabled = appointmentSlots.every(slot => slot.IsDisabled  || !slot.IsAvailable);
    
        if (allDisabled) {
            setNoDatemodal(true)
        }}
    
      }, [appointmentSlots])
    useEffect(() => {
        if(AvailableDateForAppointmentData){
          let list = [];
          let listMonths = [];
          if (AvailableDateForAppointmentData[0].entry) {
            AvailableDateForAppointmentData[0]?.entry.map((entry) => {
              list.push({
                ScheduleDate: entry?.resource?.extension[8]?.valueDateTime,
                SessionTitle: entry?.resource?.extension[10]?.valueString,
                LeaveCategory: entry?.resource?.extension[12]?.valueString,
              });
              if (
                !listMonths.includes(
                  entry?.resource?.extension[11]?.valueString
                )
              ) {
                listMonths.push(entry?.resource?.extension[11]?.valueString);
              }
            });
    
            setAvailableMonths(listMonths)
            setappointmentDates(list);
            setRescheduleModal(true);
          } else {
            setNoDatemodal(true);
          }
        }
      }, [AvailableDateForAppointmentData])
      useEffect(() => {
        if(AvailableSlotsForAppointmentData){
            if (AvailableSlotsForAppointmentData[0].entry) {
                let list = [];
                AvailableSlotsForAppointmentData[0]?.entry.map((entry) =>
                  list.push({
                    SlotID: entry?.resource?.extension[0]?.valueString,
                    StartTime: entry?.resource?.extension[2]?.valueDateTime,
                    EndTime: entry?.resource?.extension[3]?.valueDateTime,
                    AppointmentType: entry?.resource?.extension[5]?.valueString,
                    Interval: entry?.resource?.extension[6]?.valueString,
                    IsAvailable: entry?.resource?.extension[7]?.valueBoolean,
                    AppointmentCount: entry?.resource?.extension[10]?.valueString,
                    IsDisabled : entry?.resource?.extension[30]?.valueBoolean,
                    SlotMaxBookingLimit:
                      entry?.resource?.extension[27]?.valueString,
                    LocationName: entry?.resource?.extension[12]?.valueString,
                  })
                );
                // changediabledslot(list )
                // disableConsecutiveSlots(list)
                disbledSlotsBefore(list.length>0 ? list : [])
              } else {
                setAppointmentSlots([]);
              }
        }
      }, [AvailableSlotsForAppointmentData])
      useEffect(() => {
        if (showAlert === true && resultComfirm) {
            PortalAlerts("success" , "success" , RecheduleAppointmentData  )
            dispatch(appServices.gettingRecheduleAppointmentClear())
            dispatch(appServices.gettingAvailableDateForAppointmentClear())
            dispatch(appServices.gettingAvailableSlotsForAppointmentClear())
        //   // Show notification
        //   const key = `open${Date.now()}`;
        //   notification.open({
        //     message: "Success",
        //     description: resultComfirm,
        //     key,
        //   });
        //   setTimeout(() => {
        //     notification.close(key);
        //     setshowAlert(false);
        //     setresultComfirm("");
        //   }, 5000);
        }
      }, [props.showAlert]);
      useEffect(() => {
        if (resultComfirm) {
          setshowAlert(true);
          setRescheduleModal(false);
          setconfirmationmodal(false);
        }
      }, [resultComfirm]);
    useEffect(() => {
        //alert('Called Future')
        // props.getAppoint(pageSize, pageNumber);
        if(props.activeKey=="1" && Profile)
        dispatch(appServices.Appointments(fAppointmentObj))
    }, [props.activeKey , Profile])
    useEffect(() => {
        if(showAlert){
              // Dispatching the action to fetch appointments from the API
            //   dispatch(fetchfAppointmentsFromApi(pageSize, pageNumber));
            dispatch(appServices.Appointments(fAppointmentObj))
        }
    }, [showAlert])
    useEffect(() => {
      console.log(AppointmentsData , "AppointmentsData")
      if(AppointmentsData){
        setListData([AppointmentsData[0]])
        console.log(AppointmentsData , "abc")
      }
    }, [AppointmentsData])
    const disbledSlotsBefore = (list) => {
        // Step 1: Iterate through the list and group consecutive slots where IsAvailable is true
        let currentGroup = [];
        let groups = [];
    
        for (let i = 0; i < list.length; i++) {
          const slot = list[i];
    
          if (slot.IsAvailable === true) {
            // Add slot to the current group
            currentGroup.push(slot);
          } else {
            // If IsAvailable is false, check the current group and reset it
            if (currentGroup.length > 0) {
              groups.push(currentGroup);
              currentGroup = [];
            }
          }
        }
    
        // Add any remaining slots in the last group if needed
        if (currentGroup.length > 0) {
          groups.push(currentGroup);
        }
    
        // Step 2: Check each group and calculate the total interval
        groups.forEach(group => {
          const totalInterval = group.reduce((sum, slot) => {
            return sum + parseInt(slot.Interval, 10);
          }, 0);
    
          // Step 3: If the total interval is less than 60 minutes, set IsDisabled to true
          if (totalInterval < selectedDuration) {
            group.forEach(slot => {
              slot.IsDisabled = true;
            });
          }
        });
        // Step 4: Update the state with the modified slots
        setAppointmentSlots([...list]);
      };
    //   const slotForAppointment = (startDate, endDate, slotTitle) => {
    //     getUserId().then((userInfo) => {
    //       const item = JSON.parse(userInfo);
    //       var myHeaders = new Headers();
    //       setSlotLoading(true);
    //       myHeaders.append("Token", item.token);
    
    //       var requestOptions = {
    //         method: "GET",
    //         headers: myHeaders,
    //         redirect: "follow",
    //       };
    //       const queryString = `?Token=${item.token}&PatientID=${item.userid}&ProviderScheduleID=${providersechduleID}&StartDate=${startDate}&EndDate=${endDate}&AppointmentID=${AppointmentID}&SlotTitle=${slotTitle}&AppDuration=${selectedDuration}`;
    //       fetch(
    //         Settings.apiUrl + "Patient/AvailableSlotsForAppointment" + queryString,
    //         requestOptions
    //       )
    //         .then((data) => data.json())
    //         .then((json) => {
    //           if (json[0].entry) {
    //             let list = [];
    //             json[0]?.entry.map((entry) =>
    //               list.push({
    //                 SlotID: entry?.resource?.extension[0]?.valueString,
    //                 StartTime: entry?.resource?.extension[2]?.valueDateTime,
    //                 EndTime: entry?.resource?.extension[3]?.valueDateTime,
    //                 AppointmentType: entry?.resource?.extension[5]?.valueString,
    //                 Interval: entry?.resource?.extension[6]?.valueString,
    //                 IsAvailable: entry?.resource?.extension[7]?.valueBoolean,
    //                 AppointmentCount: entry?.resource?.extension[10]?.valueString,
    //                 IsDisabled : entry?.resource?.extension[30]?.valueBoolean,
    //                 SlotMaxBookingLimit:
    //                   entry?.resource?.extension[27]?.valueString,
    //                 LocationName: entry?.resource?.extension[12]?.valueString,
    //               })
    //             );
    //             setSlotLoading(false);
    //             // changediabledslot(list )
    //             console.log(list , "lisssst")
    //             // disableConsecutiveSlots(list)
    //             disbledSlotsBefore(list.length>0 ? list : [])
    //           } else {
    //             setAppointmentSlots([]);
    //             setSlotLoading(false);
    //           }
    //         })
    //         .catch((err) => {
    //           setSlotLoading(false);
    //           console.log(err);
    //         });
    //     });
    //   };
     useEffect(() => {
       if(RecheduleAppointmentData){
                     setConfirmationLoading(false);
              // setIsLoadingNot(false);
              setresultComfirm(RecheduleAppointmentData);
             
              // props.getProfile();
       }
     }, [RecheduleAppointmentData])
     
    const confirmAppointment = (mail, push, tok) => {
        getUserId().then((userInfo) => {
          const item = JSON.parse(userInfo);
          setConfirmationLoading(true);
          const slotIDs = confirmSlotData.map(slot => slot.SlotID).join(",");
    const startTime = confirmSlotData[0].StartTime;
    const endTime = confirmSlotData[confirmSlotData.length - 1].EndTime;
    const totalInterval = confirmSlotData
        .map(slot => parseInt(slot.Interval))  // Parse each interval to an integer
        .reduce((acc, curr) => acc + curr, 0)
    
    var raw = {
        resourceType: "Communication",
        extension: [
            {
                url: "AppointmentID",
                valueString: AppointmentID,
            },
            {
                url: "StartTime",
                valueString: startTime,
            },
            {
                url: "EndTime",
                valueString: endTime,
            },
            {
                url: "Duration",
                valueString: parseInt(totalInterval),
            },
            {
                url: "UpdatedBy",
                valueString: Profile[0].resource.id,
            },
            {
                url: "PatientID",
                valueString: Profile[0].resource.id,
            },
            {
                url: "IsRescheduled",
                valueString: true,
            },
            {
                url: "ScheduleSessionSlotID",
                valueString: slotIDs, // Include all SlotIDs separated by commas
            },
        ],
    }
    const payload= {
        AppointmentID : AppointmentID,
        StartTime : startTime,
        EndTime: endTime,
        Duration : parseInt(totalInterval),
        PatientID : Profile[0].resource.id,
        UpdatedBy : Profile[0].resource.id,
        IsRescheduled : true ,
        ScheduleSessionSlotID : slotIDs,
        }
         dispatch(appServices.RecheduleAppointment(payload))
    
          // alert(isEnabled)
    
        //   var requestOptions = {
        //     method: "post",
        //     headers: {
        //       Accept: "application/json",
        //       "Content-Type": "application/json",
        //     },
        //     body: raw,
        //     redirect: "follow",
        //   };
        //   fetch(
        //     Settings.apiUrl +
        //       "Patient/RecheduleAppointment?Token=" +
        //       item.token +
        //       "",
        //     requestOptions
        //   )
        //     .then((response) => response.json())
        //     .then((result) => {
        //       setConfirmationLoading(false);
        //       // setIsLoadingNot(false);
        //       setresultComfirm(result);
        //       // props.getProfile();
        //     })
        //     .catch((error) => {
        //       setConfirmationLoading(false);
        //       //setIsLoadingNot(false);
        //       console.log("error", error);
        //     });
        });
      };
    const getNextAvailableMonth = (currentMonthIndex) => {
        setAppointmentSlots([])
        for (let i = currentMonthIndex + 1; i < availableMonths.length; i++) {
          const nextMonth = availableMonths[i];
          const nextDate = new Date(nextMonth);
          // If the next available month is in the future, return it
          if (nextDate > currentDate) {
            return nextDate;
          }
        }
        return null; // Return null if no more months available
      };
    
      const getPreviousAvailableMonth = (currentMonthIndex) => {
        setAppointmentSlots([])
        for (let i = currentMonthIndex - 1; i >= 0; i--) {
          const prevMonth = availableMonths[i];
          const prevDate = new Date(prevMonth);
          // If the previous available month is in the past, return it
          if (prevDate < currentDate) {
            return prevDate;
          }
        }
        return null; // Return null if no previous months are available
      };
    
      const handleNextMonth = () => {
        const currentMonthStr = formatMonthYear(currentDate);
        const currentMonthIndex = availableMonths.findIndex(month => month === currentMonthStr);
        const nextMonth = getNextAvailableMonth(currentMonthIndex);
    
        if (nextMonth) {
          setCurrentDate(nextMonth);
        }
      };
      const renderCalendarDays = () => {
        const currentMonth = currentDate &&  currentDate.getMonth();
        const currentYear = currentDate && currentDate.getFullYear();
        const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    
        const today = new Date();
        const currentDateDay = today.getDate();
        const currentMonthNumber = today.getMonth();
        const currentYearNumber = today.getFullYear();
        let calendarDays = [];
    
        // Loop through each day in the month
        for (let day = 1; day <= daysInMonth; day++) {
          const dayDate = new Date(currentYear, currentMonth, day);
          const dayName = dayDate.toLocaleString("en-US", { weekday: "short" });
    
          // Check if the date is before today
          const isBeforeToday =
            dayDate.getFullYear() < currentYearNumber ||
            (dayDate.getFullYear() === currentYearNumber &&
              dayDate.getMonth() < currentMonthNumber) ||
            (dayDate.getFullYear() === currentYearNumber &&
              dayDate.getMonth() === currentMonthNumber &&
              day < currentDateDay);
    
          // Check if the date matches any appointment date
          const isSechduleDate = appointmentDates.some((appointment) => {
            const appointmentDate = new Date(appointment.ScheduleDate);
            return (
              appointmentDate.getDate() === dayDate.getDate() &&
              appointmentDate.getMonth() === dayDate.getMonth() &&
              appointmentDate.getFullYear() === dayDate.getFullYear()
            );
          });
          
          const appointmentDate = new Date(props.appointmentDate);
          const isAppointmentDate =
            dayDate.getDate() === appointmentDate?.getDate() &&
            dayDate.getMonth() === appointmentDate?.getMonth() &&
            dayDate.getFullYear() === appointmentDate?.getFullYear();
            const isLeaveDate = appointmentDates.some((appointment) => {
              return appointment.LeaveCategory && appointment.LeaveCategory.trim() !== '';
            });
            let dayClass = 'day-card';
    
            if (isBeforeToday) {
              dayClass += ' disabled';  // Disable past dates
            } else if (isSechduleDate) {
              // Check for the specific date in the appointment dates
              const appointment = appointmentDates.find((appointment) => {
                const appointmentDate = new Date(appointment.ScheduleDate);
                return (
                  appointmentDate.getDate() === dayDate.getDate() &&
                  appointmentDate.getMonth() === dayDate.getMonth() &&
                  appointmentDate.getFullYear() === dayDate.getFullYear()
                );
              });
            
              // Apply 'onleave' if the specific appointment has a LeaveCategory
              if (appointment && appointment.LeaveCategory && appointment.LeaveCategory.trim() !== '') {
                dayClass += ' onleave';  // Only apply 'onleave' if LeaveCategory is valid
              } else {
                dayClass += ' scheduled';  // Otherwise, apply 'scheduled'
              }
            } else if (isAppointmentDate) {
              dayClass += ' appointment';  // Highlight the appointment date
            }
          // Add the day card to the calendar days array
          calendarDays.push(
            <div
              className={dayClass}
              key={day}
              onClick={
                 isSechduleDate ?() => { handleDateClick(day)
              
                 } : () => { setAppointmentSlots([])}} // Disable click on past dates
            >
              <span>{dayName}</span>
              {day}
            </div>
          );
        }
    
        return calendarDays;
      };
      const handleDateClick = (day) => {
        const dateStr = monthNames && `${
          monthNames[currentDate.getMonth()]
        } ${day}, ${currentDate.getFullYear()}`;
        const date = new Date(dateStr);
        // Ensure that the date is valid
        if (isNaN(date)) {
          console.error("Invalid date");
        } else {
          //   const formattedDate = date.toISOString().split('T')[0];
          const formattedDate = date.toLocaleDateString("en-CA");
          // Convert formattedDate to a Date object for comparison
          const targetDate = new Date(formattedDate);
    
          // Iterate over the appointmentDates and compare
          const matchedAppointment = appointmentDates.find((appointment) => {
            const scheduleDate = new Date(appointment.ScheduleDate);
            // Compare the date part only, ignoring time and timezone differences
            return (
              scheduleDate.toISOString().split("T")[0] ===
              targetDate.toISOString().split("T")[0]
            );
          });
          const payload = {
            PatientID: Profile[0].resource.id ,
            ProviderScheduleID: providersechduleID,
            StartDate : formattedDate + " 00:00:00 ",
            EndDate : formattedDate + " 23:00:00",
            AppointmentID: AppointmentID,
            SlotTitle : matchedAppointment ? matchedAppointment.SessionTitle : "",
            AppDuration: selectedDuration
          }
          dispatch(appServices.AvailableSlotsForAppointment(payload))
          // slotForAppointment(
          //   formattedDate + " 00:00:00 ",
          //   formattedDate + " 23:00:00",
          //   matchedAppointment ? matchedAppointment.SessionTitle : ""
          // );
        }
      };
      const handleSlotClick = (slotRecord) => {
        if (parseInt(selectedDuration) <= parseInt(slotRecord.Interval)) {
          setConfirmSlotData([slotRecord]);
          setconfirmationmodal(true);
        } else {
          let remainingDuration = selectedDuration;
          let selectedSlots = [];
          let currentSlot = slotRecord;
          selectedSlots.push(currentSlot);
          remainingDuration -= parseInt(currentSlot.Interval); 
          let i = appointmentSlots.findIndex(slot => slot.SlotID === slotRecord.SlotID);
          // let i = 0;
          while (remainingDuration > 0 && i < appointmentSlots.length) {
            const nextSlot = appointmentSlots[i];
            if (nextSlot.AppointmentCount === nextSlot.SlotMaxBookingLimit) {
              setNoDatemodal(true);
              break; // Exit the loop
            }
            if (!nextSlot.IsAvailable) {
              setNoDatemodal(true);
              break; // Exit the loop
            }
            if (new Date(nextSlot.StartTime) > new Date(currentSlot.EndTime)) {
              selectedSlots.push(nextSlot); 
              remainingDuration -= parseInt(nextSlot.Interval); 
              currentSlot = nextSlot; 
            }
      
            i++; 
          }
      
          // Check if we managed to cover the full duration
          if (remainingDuration <= 0) {
            setConfirmSlotData(selectedSlots); 
            setconfirmationmodal(true);
          } else {
            setNoDatemodal(true); 
          }
        }
      };
      const handlePreviousMonth = () => {
        const currentMonthStr = formatMonthYear(currentDate);
        const currentMonthIndex = availableMonths.findIndex(month => month === currentMonthStr);
        const previousMonth = getPreviousAvailableMonth(currentMonthIndex);
    
        if (previousMonth) {
          setCurrentDate(previousMonth);
        }
      };
      const isPreviousNextMonthDisabled = (currentDate) => {
        // Convert currentDate to the same string format as availableMonths
        const formattedCurrentDate = formatMonthYear(currentDate);
      
        // Find the current month's index in availableMonths array
        const currentIndex = availableMonths.findIndex(month =>
          month === formattedCurrentDate
        );
        // Check if currentIndex is the first or last month in the availableMonths list
        const isPreviousDisabled = currentIndex === 0;
        const isNextDisabled = currentIndex === availableMonths.length - 1;
      
        return {
          isPreviousDisabled,
          isNextDisabled
        };
      };
    return (
        <div>
            {
                isAppointmentsLoading && <View style={{ textAlign: 'center', marginBottom: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
            }
            {
    AppointmentsData && AppointmentsData.length > 0 ? (
        <FlatList
            style={{
                flexDirection: 'column',
                paddingLeft: 10,
                paddingRight: 10,
                paddingBottom: 10
            }}
            data={AppointmentsData}
            renderItem={({ item }) => {
                // Safely access item.resource and its properties
                const resource = item?.resource || {};
                const extension = resource?.extension || [];
 
                // Ensure the values you pass are strings or numbers
                const appointmentDate = GetAppointmentDate(resource?.period?.start) + ' ' + GetMonthName(resource?.period?.start) + ' ' + GetYear(resource?.period?.start);
                const practiceAddress = extension[3]?.valueString || '(N/A)';
                const firstitem =  extension[2]?.valueString || '';
                const secondItem = GetDayName(resource?.period?.start) + ', ' + FormateUTCTime(resource?.period?.start);
                const patientDetails = extension[1]?.valueString || '';
                const location = extension[10]?.valueString || '(N/A)';
                const IsAllowedReschedule = extension[12]?.valueBoolean;
                const ProviderScheduleID = extension[11]?.valueString || "";
                const appointmentID = resource?.id || "";
                const StartDate = extension[13]?.valueDateTime || '';
                const EndDate = extension[14]?.valueDateTime || '';
                const Duration = extension[7]?.valueDecimal || 0;

                return (
                    <AppointmentHandler
                        styleName={'card-header text-white bg-primary'}
                        appointmentDate={appointmentDate}
                        praticeAddress={practiceAddress}
                        firstitem={firstitem}
                        secondItem={secondItem}
                        patientDetails={patientDetails}
                        location={location}
                        reasonForCancel={null}
                        IsAllowedReschedule={IsAllowedReschedule}
                        ProviderScheduleID={ProviderScheduleID}
                        appointmentID={appointmentID}
                        StartDate={StartDate}
                        EndDate={EndDate}
                        Duration={Duration}
                        showAlert={showAlert}
                        setshowAlert={setshowAlert}
                        setprovidersechduleID={setprovidersechduleID}
                        setAppointmentID={setAppointmentID}
                        AppointmentID={AppointmentID}
                        setCurrentDate={setCurrentDate}
                        setSelectedDuration={setSelectedDuration}
                        setClinicName={setClinicName}
                    />
                );
            }}
            horizontal={false}
            keyExtractor={(item) => item?.resource?.id?.toString() || Math.random().toString()}
            initialNumToRender={30}
        />
    ) : !isAppointmentsLoading && (
        <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
            <Text style={{ marginTop: 10 }}>No Records Found</Text>
        </View>
    )
}

<Modal
          title="Appointment Reschedule"
          centered
          open={rescheduleModal}
          closable={false}
          style={{ top: 10, bottom: 90, overflow: "hidden" }}
          width={1000}
          footer={[
            <>
              <Button
                key="back"
                onClick={() => {
                  setAppointmentSlots([]);
                  setRescheduleModal(false);
                  setCurrentDate(new Date(props.appointmentDate));
                  dispatch(appServices.gettingAvailableDateForAppointmentClear())
                  dispatch(appServices.gettingAvailableSlotsForAppointmentClear())
                }}
              >
                Cancel
              </Button>
            </>,
          ]}
        >
          {isAvailableDateForAppointmentData ? (
            <Spin
              className="d-flex justify-content-center w-100"
              size="small"
            ></Spin>
          ) : (
            <>
              <div className="calendar-container">
                <div className="calendar-header">
                <div onClick={ isPreviousNextMonthDisabled(currentDate).isPreviousDisabled ? null : handlePreviousMonth}>
                <svg style={{ marginRight: 10 }}  width={22} height={22} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
	 viewBox="0 0 24 24" >

<path className={isPreviousNextMonthDisabled(currentDate).isPreviousDisabled ? "st4" :"st3"} d="M2.8,24h18.4c1.5,0,2.8-1.2,2.8-2.8V2.8C23.9,1.2,22.7,0,21.1,0H2.8C1.2,0,0,1.2,0,2.8v18.5
	C0,22.8,1.2,24,2.8,24z M7.2,11.4l1.3-1.3l0,0l5.7-5.7c0.4-0.4,1-0.4,1.3,0l1.3,1.3c0.4,0.4,0.4,1,0,1.3l-5,5l4.9,4.9
	c0.4,0.4,0.4,1,0,1.3l-1.3,1.3c-0.4,0.4-1,0.4-1.3,0l-6.9-6.9C6.8,12.4,6.8,11.8,7.2,11.4z"/>
</svg></div>
                  <span className="monthtext" id="calendar-month-year">{`${
                    monthNames[ currentDate && currentDate.getMonth()]
                  } ${ currentDate && currentDate.getFullYear()}`}</span>
                  <div onClick={isPreviousNextMonthDisabled(currentDate).isNextDisabled ? null : handleNextMonth}>
                  <svg style={{ marginLeft: 10 }}  width={22} height={22} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
	 viewBox="0 0 24 24" >
<path className={isPreviousNextMonthDisabled(currentDate).isNextDisabled ? "st4" :"st3"} d="M21.1,0H2.8C1.2,0,0,1.2,0,2.8v18.5C0,22.8,1.2,24,2.8,24h18.4c1.5,0,2.8-1.2,2.8-2.8V2.8
	C23.9,1.2,22.7,0,21.1,0z M16.7,12.6l-1.3,1.3l0,0l-5.7,5.7c-0.4,0.4-1,0.4-1.3,0l-1.3-1.3c-0.4-0.4-0.4-1,0-1.3l5-5L7.3,7
	c-0.4-0.4-0.4-1,0-1.3l1.3-1.3C9,4,9.6,4,9.9,4.4l6.9,6.9C17.1,11.6,17.1,12.2,16.7,12.6z"/>
</svg> </div>
                </div>
                <div className="d-flex flex-row align-items-center ">
    <span className="dot green-dot"></span> <span className="keytext">Original Appointment</span> 
    <span className="dot blue-dot"></span> <span className="keytext">Available Days</span> 
  </div>
                <div className="calendar-days">{renderCalendarDays()}</div>
              </div>
              <div className="container">
                <div className="slots-header">Available Slots</div>

                {isAvailableSlotsForAppointmentData ? (
                  <Spin
                    className="d-flex justify-content-center w-100"
                    size="small"
                  ></Spin>
                ) : (
                  <div
                    className={                                                                                                            
                      appointmentSlots.length > 0 ? "container-time-grid" : ""
                    }
                  >
                    {appointmentSlots.length > 0 ? (
                      appointmentSlots.map((slot) => {
                        // Check the conditions to disable the slot
                        const isDisabled =
                          (slot.AppointmentCount === slot.SlotMaxBookingLimit ||
                          !slot.IsAvailable) || slot.IsDisabled

                        return (
                          <div
                            key={slot.SlotID}
                            className={`day-card-time ${
                              isDisabled ? "disabled" : ""
                            }`}
                            // Optionally prevent click events on disabled slots
                            onClick={
                              isDisabled
                                ? (e) => e.preventDefault()
                                : () => handleSlotClick(slot)
                            }
                          >
                            <div className="time">
                              {formatTime(slot.StartTime)}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="noslotsText"> No Available Slots </div>
                    )}
                  </div>
                )}
              </div>
            </>
          )}
        </Modal>
        <Modal
          title="Confirm Appointment"
          centered
          open={confirmationmodal}
          closable={false}
          // onOk={() => {
          //     setconfirmationmodal(false);

          // }}loading={loading}
          // onCancel={() => setconfirmationmodal(false)}
          style={{ top: 10, bottom: 90, overflow: "hidden" }}
          width={500}
          footer={[
            <>
              <Button
                key="back"
                onClick={() => {
                  setAppointmentSlots([]);
                  setconfirmationmodal(false);
                }}
              >
                Cancel
              </Button>
              <Button
                loading={confirmationLoading}
                key="submit"
                type="primary"
                onClick={() => {

                  confirmAppointment();
                }}
              >
                Confirm
              </Button>
            </>,
          ]}
        >
          <div className="slot-details">
            <div>
              <span className="label">Appointment:</span>{" "}
              <span id="formattedStartTime">
                {" "}
                {confirmSlotData
                  ? dateOnly(confirmSlotData[0].StartTime)+", "+ timeOnly(confirmSlotData[0].StartTime)+" - "+ timeOnly(confirmSlotData[confirmSlotData.length - 1].EndTime)
                  : ""}
              </span>
            </div>
            <div>
              <span className="label">Clinic:</span>{" "}
              <span id="appointmentType">
                {clinicName}
              </span>
            </div>
            {/* <div>
              <span className="label">Location:</span>{" "}
              <span id="location">{confirmSlotData?.location}</span>
            </div> */}
          </div>
        </Modal>
        <Modal
          title=""
          centered
          open={noDatemodal}
          closable={false}
          // onOk={() => {
          //     setconfirmationmodal(false);

          // }}loading={loading}
          // onCancel={() => setconfirmationmodal(false)}
          style={{ top: 10, bottom: 90, overflow: "hidden" }}
          width={500}
          footer={[
            <>
              <Button
                loading={confirmationLoading}
                key="submit"
                type="primary"
                onClick={() => {
                  setNoDatemodal(false);
                  history.push({
                    pathname: "/emails",
                    state: { fromButton: true }, // Passing state with navigation
                  });
                }}
              >
                Go to Messaging
              </Button>
              <Button
                key="back"
                onClick={() => {
                  setNoDatemodal(false);
                }}
              >
                Cancel
              </Button>
            </>,
          ]}
        >
          <div className="slot-details">
            <span>
              Unfortunately there are no suitable slots available. Please use
              your portal messaging section to contact the NCC team directly.{" "}
            </span>
          </div>
        </Modal>
        </div>

    );
}



// function mapStateToProps(state) {
//     return {
//         FutureAppointments: state.FutureAppointments
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return {
//         getAppoint: (pageSize, pageNumber) => dispatch(fetchfAppointmentsFromApi(pageSize, pageNumber))
//     }
// }
// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(FutureAppointmentView)

export default FutureAppointmentView
